import axios from "axios";

// CRA uses REACT_APP_* env vars (not VITE_*)
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // send httpOnly refresh cookie
  timeout: 15000,
});

// ── In-memory access token (never localStorage — XSS-safe) ──
let accessToken = null;
export const setAccessToken = (t) => (accessToken = t);
export const getAccessToken = () => accessToken;

// Attach access token to every request
api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

// ── Auto-refresh on 401 (once per request) ──
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";

    if (
      status === 401 &&
      !original._retry &&
      !url.includes("/auth/refresh") &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/signup") &&
      !url.includes("/auth/google")
    ) {
      original._retry = true;

      try {
        refreshing =
          refreshing ||
          api.post("/api/auth/refresh").finally(() => (refreshing = null));

        const { data } = await refreshing;
        setAccessToken(data.accessToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(original);
      } catch {
        setAccessToken(null);
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;

